<template>
  <b-row>
    <b-col>
      <h4>{{ $t('updater.propertiesToUpdate') }}</h4>
      <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-checkbox-group
          id="checkbox-group-2"
          v-model="selectedFieldsToChange"
          :aria-describedby="ariaDescribedby"
          name="flavour-2"
          class="mb-3"
        >
          <b-form-checkbox class="bg-green" v-for="column in venueWineOptions" :value="column.key" :key="column.key" @change="changedValue(column.key)" :disabled="selectedMode === 'delete'" style="display: flex; align-items: center;">
                {{ column.value }} 
                <span v-if="column.key == 'purchasePrice'" class="ml-xs">{{ $t('updater.withWinesupplier') }}</span>
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-row class="mapping mt-4" v-if="notFoundColumns.length > 0">
        <b-col>
          <h4>Nicht gefundene Spalten zuordnen:</h4>

          <b-row v-for="(column, index) in notFoundColumns" :key="column" :style="(index > 0 ? 'margin-top: 5px;' : '') + (index%2 == 0 ? 'background-color: #222325;' : '')">
            <b-col style="display: flex; align-items: center; margin-left: 3px;width: 100px;">
              {{ columnNameFromValue(column) }}
            </b-col>
            <b-col style="display: flex; justify-content: center;">
              <img class="arrow-icon" src="../../assets/img/icon-dropdown.svg">
            </b-col>
            
            <b-col>
              <b-form-select class="v2 green" v-model="rowMappingObject[column]" :options="csvColumns" @change="triggerReload = !triggerReload">
                <template #first>
                  <b-form-select-option value="" disabled>{{ $t('general.dropdownText') }}</b-form-select-option>
                </template>
              </b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>

    <b-row class="mb-3 mt-5 more-options">
      <h4>{{ $t('updater.moreOptions') }}</h4>
  
          <b-form-group label="" >
          <b-form-radio class="bg-green" v-for="mode in writeModes" :value="mode" :key="mode" v-model="selectedMode" @change="changedMode(mode)" style="display: flex; align-items: center;">
      
                <span v-if="mode == constants.DELETE_MODE" class="ml-xs">{{ $t('updater.deleteWine') }}</span>
                <span v-else-if="mode == constants.UPDATE_ADD_MODE" class="ml-xs">{{ $t('updater.addToProduct') }}</span>
                <span v-else-if="mode == constants.UPDATE_REMOVE_MODE" class="ml-xs">{{ $t('updater.dontOverwrite') }}</span>
                <span v-else-if="mode == constants.OVERWRITE_MODE" class="ml-xs">{{ $t('updater.overwrite') }}</span>
                <span v-else-if="mode == constants.UNDELETE_MODE" class="ml-xs">{{ $t('updater.undeleteWine') }}</span>
                <span v-else class="ml-xs">{{ mode }}</span>

          </b-form-radio>
       
      </b-form-group>

     
    </b-row>

    <b-row v-if="!buttonDisabled">
      <h4>{{ $t('updater.columnsToImport') }}</h4>
      <b-alert class="updater" :show=true>{{ Object.keys( rowMappingObject).map((key) => { return "Spalte " + rowMappingObject[key] + " zu "+ columnNameFromValue(key)}).join(', ') }}</b-alert>
    </b-row>

      
    <ButtonFooter :backButtonVisible="true" :okButtonDisabled="buttonDisabled"
           :backButtonLabel="$t('general.buttons.back')" :okButtonLabel="$t('general.buttons.forward')" :okAction="() => finishedMapping(rowMappingObject, selectedMode, true)" :backAction="handleBackFromStep1"/>
  </b-row>
</template>
<script>
import ButtonFooter from '@/components/modals/ButtonFooter.vue'
import constants from "@/utils/constants";

export default {
  name: "TargetMapping",
  components: {
    ButtonFooter
  },
  props: {
    csvColumns: Array,
   
    finishedMapping: Function,
    rowMappingObjectStart: Object,
    modeStart: String,
  },
  data() {
    return {

      selectedFieldsToChange: [],
      venueWineOptions: [
        {key: "amountFloat", value: "Anzahl"}, 
        {key: "sellingPrice", value: "VK"}, 
        {key: "storable", value: "Regal"}, 
        {key: "articleNumber", value: "Artikelnummer"}, 
        {key: "comments", value: "Kommentar"}, 
        {key: "cashNote", value: "Kassennotiz"}, 
        {key: "purchasePrice", value: "EK"}, 
        {key: constants.DATE_TARGET, value: 'Wareneingang'}],
      rowMappingObject: {},
      notFoundColumns: [],
      triggerReload: false,

      showAlert: false,
      selectedMode: '',
      writeModes: [constants.UPDATE_ADD_MODE, constants.OVERWRITE_MODE,  constants.UPDATE_REMOVE_MODE, constants.DELETE_MODE, constants.UNDELETE_MODE],
    }
  },
  created() {
    this.rowMappingObject = this.rowMappingObjectStart;
    this.selectedMode = this.modeStart ? this.modeStart : '';
    this.addValuesFromMappingObject()
  },
  methods: {
    handleBackFromStep1() {
      this.$emit('backFromStep1');
    },
    changedValue(column) {
      this.$nextTick(() => {
        if (this.selectedFieldsToChange.indexOf(column) > -1) {
          console.log('adding column', column);
          if (this.csvColumns.indexOf(this.columnNameFromValue(column)) == -1){
            console.log('not found column', column);
            this.notFoundColumns.push(column);
            this.rowMappingObject[column] = '';
          } else {
            console.log('found column', column);
            this.rowMappingObject[column] = this.columnNameFromValue(column);
          }
        } else {
          this.notFoundColumns = this.notFoundColumns.filter((item) => item != column);
          delete this.rowMappingObject[column];
        }
        this.triggerReload = !this.triggerReload;
      })
      if (column == 'purchasePrice') {
        if (this.selectedFieldsToChange.indexOf('purchasePrice') > -1) {
          this.selectedFieldsToChange.push('supplier');
          this.selectedFieldsToChange.push('vendorArticleNumber');
          this.selectedFieldsToChange.push('vendorArticleName');
        } else {  
          this.selectedFieldsToChange.splice(this.selectedFieldsToChange.indexOf('supplier'), 1);
          this.selectedFieldsToChange.splice(this.selectedFieldsToChange.indexOf('vendorArticleNumber'), 1);
          this.selectedFieldsToChange.splice(this.selectedFieldsToChange.indexOf('vendorArticleName'), 1);
        }
        this.changedValue('supplier');
        this.changedValue('vendorArticleNumber');
        this.changedValue('vendorArticleName');
      } 
    },
    addValuesFromMappingObject(){

      var keys = Object.keys(this.rowMappingObject)
      for (var i = 0; i < keys.length; i++) {
        if (this.rowMappingObject[keys[i]] != null && this.rowMappingObject[keys[i]] != undefined && this.rowMappingObject[keys[i]] != '') {
          this.selectedFieldsToChange.push(keys[i]);
        }
      }
    },
    changedMode(mode) {
      if (mode == 'delete') {
        {
          this.selectedFieldsToChange=[]
        }
      }
    },
    columnNameFromValue(value) {
      
      var found = this.venueWineOptions.find((item) => item.key == value);
      if (value == 'vendorArticleNumber') {
        return 'Lieferanten Artikelnummer';
      }
      if (value == 'vendorArticleName') {
        return 'Lieferanten Artikelname';
      }
      if (value == 'supplier') {
        return 'Bezugsquelle';
      }
      return found ? found.value : value;
      
    }
  },
  computed: {
    buttonDisabled() {
      this.triggerReload 
      var keys = Object.keys(this.rowMappingObject)
      for (var i = 0; i < keys.length; i++) {
        if (this.rowMappingObject[keys[i]] == null || this.rowMappingObject[keys[i]] == undefined || this.rowMappingObject[keys[i]] == '') {
          return true;
        }
      }
      return this.selectedFieldsToChange.length === 0 && this.selectedMode != constants.DELETE_MODE && this.selectedMode != constants.UNDELETE_MODE;
    },
    constants() {
      return constants;
    }
  },
  watch: {
    rowMappingObjectStart: {
      handler: function (val) {
        this.rowMappingObject = val;
        this.addValuesFromMappingObject()
      },
      deep: true
    },
    modeStart: {
      handler: function (val) {
        this.selectedMode = val ? val : '';
      },
      deep: true
    }
  }
}
</script>
<style scoped>

</style>